import { colors } from '@material-ui/core';

import EnergairLogo from 'src/assets/energair_logo.svg';
import EnergairIcon from 'src/assets/energair_favicon.png';

const energairBrandConfig = {
  urls: ['energair.prosaris.ca', 'energair-staging-us.prosaris.ca'],
  theme: {
    PRIMARY_COLOR: '#782475',
    PRIMARY_DARK: '#661e63',
    SECONDARY_COLOR: '#6562a9',
    PRIMARY_TEXT: '#404040',
    ACCENT_TEXT: '#ffffff',
    DARK_BACKGROUND: '#6562a9',
    SUCCESS: '#0D7B3B',
    WARNING: '#B29600',
    ERROR: '#BD1717',
    BRANDING_MAIN: '#ffffff',
    BRANDING_SHADE: '#ffffff',
    MAIN_LAYOUT: {
      BACKGROUND: '#ffffff',
      PRIMARY_COLOR: '#782475',
      PRIMARY_DARK: '#661e63',
      SECONDARY_COLOR: '#782475',
      ACCENT_COLOR: '#6562a9',
      TEXT_PRIMARY: '#404040',
      TEXT_SECONDARY: '#404040',
      INPUT_BACKGROUND: '#ffffff',
      INPUT_BORDER: '#404040',
      BUTTON_BACKGROUND: '#782475',
      BUTTON_COLOR: '#ffffff',
      BUTTON_HOVER: '#661e63',
    },
    UNIT_TOGGLE_BUTTON: {
      ACTIVE: {
        BACKGROUND: '#782475',
        COLOR: '#ffffff',
        HOVER: {
          BACKGROUND: '#661e63',
          COLOR: '#ffffff',
        },
      },
      INACTIVE: {
        BACKGROUND: '#ffffff',
        COLOR: '#782475',
        HOVER: {
          BACKGROUND: colors.grey[100],
          COLOR: '#782475',
        },
      },
    },
    TOPBAR: {
      ACTIVE: {
        BACKGROUND: '#782475',
        COLOR: '#ffffff',
      },
      INACTIVE: {
        BACKGROUND: '#ffffff',
        COLOR: '#782475',
      },
      TEXT: '#404040',
    },
  },
  logo: {
    login: {
      src: EnergairLogo,
      height: 90,
      alt: 'ENERGAIR Logo',
    },
    topbar: {
      src: EnergairLogo,
      height: 30,
      alt: 'ENERGAIR Logo',
    },
    report: {
      src: EnergairLogo,
      height: 25,
      alt: 'ENERGAIR Logo',
    },
    coverPage: {
      src: EnergairLogo,
      height: 45,
      alt: 'ENERGAIR Logo',
    },
    favicon: {
      src: EnergairIcon,
    },
  },
  title: 'ENERGAIR Dashboard',
  bannersEnabled: false,
  poweredByEnabled: true,
  ol1Enabled: true,
  overrideExistingRegistration: false,
  viewOnboardingProgress: false,
  companyInfo: {
    name: 'PROSARIS',
    email: 'support@prosaris.ca',
  },
};

export default energairBrandConfig;
